<script setup lang="ts">
import { Search } from "@lucide/vue";
import { ListboxFilter, type ListboxFilterProps, useForwardProps } from "reka-ui";
import { twMerge } from "tailwind-merge";
import { computed, type HTMLAttributes, normalizeClass } from "vue";

import { useCommand } from "./index.ts";

defineOptions({
	inheritAttrs: false,
});

const props = defineProps<
	ListboxFilterProps & {
		class?: HTMLAttributes["class"];
	}
>();

const delegatedProps = computed(() => {
	const { class: _, ...delegated } = props;

	return delegated;
});

const forwardedProps = useForwardProps(delegatedProps);

const { filterState } = useCommand();
</script>

<template>
	<div class="flex items-center border-b px-3" cmdk-input-wrapper>
		<Search class="mr-2 size-4 shrink-0 opacity-50" />
		<ListboxFilter
			v-bind="{ ...forwardedProps, ...$attrs }"
			v-model="filterState.search"
			auto-focus
			:class="
				twMerge(
					'flex h-10 w-full rounded-md bg-transparent py-3 text-sm outline-hidden placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50',
					normalizeClass(props.class),
				)
			"
		/>
	</div>
</template>
